<div style="border: 2px groove black;"
     class="my-2 py-2 px-2"
     *ngIf="query$ | async">
  This is Miltenyi Top Filters Component
</div>
